const url_api = "https://returns.the-oz.com/store-front/v1/shop";
const CSS_ERROR_CLASS = "hasError";
const EMAIL_REGEX = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
const emailRegex = new RegExp(EMAIL_REGEX);
const cacheMap = new Map();

//Steps
const STEPS = { STEP_1: 1, STEP_2: 2, STEP_3: 3 };


let queryParams;

const style = `
<style>
/* Order returns */
.container {
  width: 100%;
}
.container .order-returns {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 3rem 0;
}
.container .order-returns .title {
  margin: 2rem 0;
  text-align: center;
  text-transform: none;
  font-size: 14px;
  font-weight: 600;
  width: 20rem;
}
.container .order-returns .main {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-style: solid;
  border-width: 1px;
  border-color: #c8c8c8;
}
.container .order-returns .main .cta {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin: 1rem 0;
}
.container .order-returns .main .cta button {
  font: inherit;
  cursor: pointer;
  border: 1px solid #222;
  padding: 18px 30px;
  color: var(--oz-app-return-color-button);
  background-color: var(--oz-app-return-color-button-bg);
}
.container .order-returns .main .cta button:hover {
  color: var(--oz-app-return-color-button-bg) !important;
  background-color: var(--oz-app-return-color-button) !important;
}
.container .order-returns .main.step1 {
  width: 40%;
  box-sizing: border-box;
  padding: 1rem 3rem;
}
.container .order-returns .main.step1 .row {
  width: 100%;
  padding: 10px 0px;
}
.container .order-returns .main.step1 .row .spacer {
  margin: 3em 0;
}
.container .order-returns .main.step1 .row input {
  width: 100%;
  padding: 1rem 3px;
}
.container .order-returns .main.step1 .row input::placeholder {
  text-transform: none;
}
.container .order-returns .main.step1 .row .btn.cta {
  padding-right: 5%;
  padding-left: 5%;
}
.container .order-returns .main.step1 .row.first {
  margin-bottom: 10px !important;
}
.container .order-returns .main.hidden {
  display: none;
}
.container .order-returns .main.step2, .container .order-returns .main.step3 {
  width: 60rem;
}
.container .order-returns .main.step2 .invite, .container .order-returns .main.step3 .invite {
  align-self: flex-start;
  padding: 0 0 0 1.2rem;
  font-weight: 500;
  margin-bottom: 1rem;
}
.container .order-returns .main.step2 .content, .container .order-returns .main.step3 .content {
  width: 100%;
}
.container .order-returns .main.step2 .content .orderReturn, .container .order-returns .main.step3 .content .orderReturn {
  padding: 0.5rem;
}
.container .order-returns .main.step2 .content .orderReturn h6, .container .order-returns .main.step3 .content .orderReturn h6 {
  font-size: 12px;
  margin: 0;
  text-align: center;
  line-height: 1.25;
  font-weight: 400;
}
.container .order-returns .main.step2 .content .orderReturn .items, .container .order-returns .main.step3 .content .orderReturn .items {
  width: 100%;
  display: flex;
  flex-direction: column;
}
.container .order-returns .main.step2 .content .orderReturn .items .item.head, .container .order-returns .main.step3 .content .orderReturn .items .item.head {
  font-weight: 600;
}
.container .order-returns .main.step2 .content .orderReturn .items .item.head .itemLabel, .container .order-returns .main.step3 .content .orderReturn .items .item.head .itemLabel {
  width: calc(23rem + 70px);
}

.container .order-returns .main.step2 .content .orderReturn .items .item, 
.container .order-returns .main.step3 .content .orderReturn .items .item {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  padding: 3px;
}
.container .order-returns .main.step2 .content .orderReturn .items .item .mobileTitles, 
.container .order-returns .main.step3 .content .orderReturn .items .item .mobileTitles {
  display: none;
}
.container .order-returns .main.step2 .content .orderReturn .items .item .nr, 
.container .order-returns .main.step3 .content .orderReturn .items .item .nr {
  width: 3rem;
  text-align: center;
}
.container .order-returns .main.step2 .content .orderReturn .items .item .photo, 
.container .order-returns .main.step3 .content .orderReturn .items .item .photo {
  width: 70px;
}
.container .order-returns .main.step2 .content .orderReturn .items .item .itemLabel, 
.container .order-returns .main.step3 .content .orderReturn .items .item .itemLabel {
  width: 23rem;
  padding-left: 3px;
}
.container .order-returns .main.step2 .content .orderReturn .items .item .itemQuantity, 
.container .order-returns .main.step3 .content .orderReturn .items .item .itemQuantity {
  width: 5rem;
}
.container .order-returns .main.step2 .content .orderReturn .items .item .itemQuantity select, 
.container .order-returns .main.step3 .content .orderReturn .items .item .itemQuantity select {
  padding: 0 0 0 0;
}
.container .order-returns .main.step2 .content .orderReturn .items .item .itemReason, 
.container .order-returns .main.step3 .content .orderReturn .items .item .itemReason {
  width: 28rem;
}
.container .order-returns .main.step2 .content .orderReturn .items .item .itemReason select, 
.container .order-returns .main.step3 .content .orderReturn .items .item .itemReason select {
  padding: 0 0 0 10px;
}
.container .order-returns .main.step2 .content .orderReturn .items .item select, 
.container .order-returns .main.step3 .content .orderReturn .items .item select {
  width: 95%;
  height: 1.5rem;
  min-height: 1.6rem;
  margin-bottom: 0;
  text-align-last: center;
}
.container .order-returns .main.hidden {
  display: none;
}
.container .order-returns .main.step3 .orderReturn:nth-child(even) {
  background: #FFFFFF;
}
.container .order-returns .main.step3 .orderReturn:nth-child(odd) {
  background: #FFFFFF;
}
.container .order-returns .main .hasError {
  border-bottom: solid red 1px !important;
}
.container .order-returns .main .errorMessage {
  color: red;
  margin-bottom: 0.5rem;
  font-size: 10px;
  margin-top: 1rem;
}
.container .order-returns .main .loader {
  display: block;
  position: fixed;
  z-index: 10;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: #A9A9A9;
  opacity: 0.6;
}
.container .order-returns .main .wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}
.container .order-returns .main .hidden {
  display: none !important;
}
.container .order-returns .main .center {
  text-align: center;
}

@media only screen and (max-width: 479px) {
  .container .order-returns {
    margin: 0.5rem 0;
    width: 90%;
    margin: 0.5rem auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .container .order-returns .main.step1, 
  .container .order-returns .main.step2, 
  .container .order-returns .main.step3 {
    width: 100%;
  }
  .container .order-returns .main.step2 .content, 
  .container .order-returns .main.step3 .content {
    padding: 0;
  }
  .container .order-returns .main.step2 .invite, .container .order-returns .main.step3 .invite {
    margin-bottom: 0;
  }  
  .container .order-returns .main.step2 .content .orderReturn .items .item.head, 
  .container .order-returns .main.step3 .content .orderReturn .items .item.head {
    display: none;
  }
  .container .order-returns .main.step2 .content .orderReturn .items .item, 
  .container .order-returns .main.step3 .content .orderReturn .items .item {
    flex-direction: column;
    align-items: baseline;
  }
  .container .order-returns .main.step2 .content .orderReturn .items .item .nr, 
  .container .order-returns .main.step3 .content .orderReturn .items .item .nr {
    width: auto;
    text-align: left;
    display: flex;
    flex-direction: row;
    justify-content: left;
    align-items: baseline;
  }
  .container .order-returns .main.step2 .content .orderReturn .items .item .itemLabel, 
  .container .order-returns .main.step3 .content .orderReturn .items .item .itemLabel {
    width: auto;
  }
  .container .order-returns .main.step2 .content .orderReturn .items .item .itemReason, 
  .container .order-returns .main.step3 .content .orderReturn .items .item .itemReason {
    width: auto;
    margin: 0;
    text-align: left;
  }
  .container .order-returns .main.step2 .content .orderReturn .items .item .itemQuantity select, 
  .container .order-returns .main.step3 .content .orderReturn .items .item .itemQuantity select {
    padding: 0;
    font-size: 16px;
  }
  .container .order-returns .main.step2 .content .orderReturn .items .item .itemQuantity, 
  .container .order-returns .main.step3 .content .orderReturn .items .item .itemQuantity {
    min-width: 100px;
    text-align: left;
  }
  .container .order-returns .main.step2 .content .orderReturn .items .item .mobileTitles, 
  .container .order-returns .main.step3 .content .orderReturn .items .item .mobileTitles {
    display: block;
    font-size: 11px;
    text-transform: uppercase;
    padding-top: 1.2em;
  }
  .container .order-returns .main.step2 .content .orderReturn .items .item .mobileTitles, 
  .container .order-returns .main.step3 .content .orderReturn .items .item .mobileTitles {
    padding-top: 0;
  }
  .container .order-returns .main.step1 input[type="text"],
  .container .order-returns .main.step1 input[type="email"] {
      -webkit-text-size-adjust: 100%;
      font-size: 16px;
  }
}
</style>`;

export default class OrderReturn extends HTMLElement {
  constructor() {
    super();
    this.step = 1;
    this.orderReturnableItems = [];
    this.ordersReturned = [];
    this.attachShadow({ mode: 'open' });

    this.settings = JSON.parse(this.getAttribute('data-config'));
    this.reasons = JSON.parse(this.getAttribute('data-reasons'));

    this.shopUrl = `https://${this.settings.RETURNS_STORE_NAME}.myshopify.com`;
    this.url_base = `${url_api}/${this.settings.RETURNS_STORE_NAME}`;
  }

  connectedCallback() {
    //insert HTML content
    this.shadowRoot.innerHTML = `${style}${this.getHtml()}`;
    this.shadowRoot.getElementById('startReturn').onclick = () => this.startReturn();
    this.shadowRoot.getElementById('orderNumber').onblur = (event) => this.onBlurField(event);
    this.shadowRoot.getElementById('customerEmail').onblur = (event) => this.onBlurField(event);

    this.init();
  }

  // called after data query returned
  updateReturnableItems() {
    if (this.orderReturnableItems.length > 0) {
      this.insertItemsInForm(this.orderReturnableItems);
    } else {
      this.insertItemsNotAvailable();
    }
  }

  // called after data query returned
  updateOrdersReturned() {
    if (this.ordersReturned.length > 0) {
      this.insertListingOrderReturns(this.ordersReturned);
    }
  }
  // called in order to show next step and hide the previous one (if any)
  updateStep() {
    const selector = `.step${this.step}`;
    this.shadowRoot.querySelector(selector).classList.remove("hidden");
  }

  // called after web component initialisation
  async init() {
    if (window.location.search !== "") {
      const queryString = window.location.search;
      const query = queryString.startsWith('?') ? queryString.substring(1) : queryString;
      queryParams = query.split("&").reduce((acc, item) => {
        const values = item.split("=");
        acc[values[0]] = values[1];
        return acc;
      }, {});

      // is valid queryParams
      if (queryParams.userid && queryParams.step && queryParams.ordernr && queryParams.token) {
        this.url_base += `/user/${queryParams.userid}`;

        if (queryParams.step === `${STEPS.STEP_2}`) {
          this.step = STEPS.STEP_2;
          // Step2: connected user, make a order return
          await this.showStep2(queryParams.ordernr, "");
        }
        if (queryParams.step === `${STEPS.STEP_3}`) {
          this.step = STEPS.STEP_3;
          // Step3: connected user, view all returned orders
          await this.showStep3(queryParams.ordernr, "");
        }
      } else {
        queryParams = null;
        this.showStep1();
      }
    } else {
      // Step1: non-connected user
      this.showStep1();
    }
  }

  showStep1() {
    this.step = STEPS.STEP_1;
    this.showStep();
  }

  async showStep2(ordernr, email) {
    try {
      this.toggleLoader(true);
      await this.getOrderReturnableItems(ordernr, email);
    } catch (err) {
      if (!queryParams) {
        this.step = STEPS.STEP_1;
        this.setError(err, STEPS.STEP_1);
      } else {
        this.step = STEPS.STEP_2;
        this.setError(err, STEPS.STEP_2);
        //add cta
        this.insertBackButton();
      };
    }
    finally {
      this.toggleLoader(false);
      this.showStep();
    };
  }

  async showStep3(ordernr, email) {
    try {
      this.toggleLoader(true);
      await this.getOrderReturns(ordernr, email);

    } catch (err) {
      this.setError(err, STEPS.STEP_3);
    }
    finally {
      this.toggleLoader(false);
      this.showStep();
    };
  }

  // called in Step1: Non-connected user
  async startReturn() {
    this.resetError();

    if (!this.checkErrors(['orderNumber', 'customerEmail'])) {
      return;
    }

    const orderNumber = this.shadowRoot.querySelector('#orderNumber').value;
    const customerEmail = this.shadowRoot.querySelector('#customerEmail').value;

    await this.showStep2(orderNumber, customerEmail);
  }

  // called in Step2: retrieve the returnable items for the current order and customer
  async getOrderReturnableItems(orderNumber, customerEmail) {
    const { ERR_INVALID_INFOS, ERR_INVALID_DELAY } = this.settings;
    const order = encodeURIComponent(orderNumber);
    const url = queryParams ? `${this.url_base}/order/${queryParams.ordernr}/returnable` : `${this.url_base}/returnable?order=${order}&email=${customerEmail}`;

    const response = await fetch(
      url,
      {
        method: 'GET',
        ...(queryParams &&
        {
          headers: {
            'x-authorization': queryParams.token
          }
        }
        )
      }
    );

    if (!response.ok) {
      if (response.status === 460) {
        throw new Error(ERR_INVALID_DELAY);
      }
      throw new Error(ERR_INVALID_INFOS);
    }

    const data = await response.json();
    const { returnableItems } = data;

    this.step = STEPS.STEP_2;

    if (returnableItems.length > 0) {
      this.orderReturnableItems = returnableItems;
    } else {
      this.orderReturnableItems = [];
    }

    this.updateReturnableItems();
    this.showStep();
    this.scrollTop();
  }

  // called in Step2: confirm the current return request
  async confirmReturn() {
    const orderNumber = this.shadowRoot.querySelector('#orderNumber').value;
    const email = this.shadowRoot.querySelector('#customerEmail').value;
    const payload = this.getConfirmationPayload();

    if (payload) {
      this.resetError();
      try {
        await this.sendReturns(orderNumber, email, payload);
        this.scrollTop();

      } catch (err) {
        console.log(err);
        this.setError(err, STEPS.STEP_2);
      }
    }
  }

  // called in Step2: send the current return request
  async sendReturns(orderNumber, email, payload) {
    const { RETURNS_LANGUAGE } = this.settings;
    const order = encodeURIComponent(orderNumber);
    const url = queryParams ? `${this.url_base}/order/${queryParams.ordernr}/return?language=${RETURNS_LANGUAGE}` : `${this.url_base}/return?order=${order}&email=${email}&language=${RETURNS_LANGUAGE}`;

    try {
      this.toggleLoader(true);

      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ...(queryParams && { 'x-authorization': queryParams.token })
        },
        body: JSON.stringify(payload)
      });

      if (!response.ok) {
        throw new Error("An error occured While processing your request.");
      }

      const data = await response.json();

      this.step = STEPS.STEP_3;
      this.insertOrderReturn(data);
      this.showStep();

    } catch (err) {
      this.setError(err, STEPS.STEP_2);
    }
    finally {
      this.toggleLoader(false);
    };
  }

  // called in Step3: retrieve the returned orders for current customer
  async getOrderReturns(orderNumber, customerEmail) {
    const { ERR_INVALID_INFOS } = this.settings;
    const order = encodeURIComponent(orderNumber);
    const url = queryParams ? `${this.url_base}/order/${queryParams.ordernr}/return` : `${this.url_base}/return?order=${order}&email=${customerEmail}`;
    const response = await fetch(
      url,
      {
        method: 'GET',
        ...(queryParams &&
        {
          headers: {
            'x-authorization': queryParams.token
          }
        }
        )
      }
    );

    if (!response.ok) {
      throw new Error(ERR_INVALID_INFOS);
    }

    const data = await response.json();
    const { orderReturns } = data;

    this.ordersReturned = orderReturns;
    this.updateOrdersReturned();
  }

  getConfirmationPayload() {
    const { ERR_EMPTY_FIELDS } = this.settings;
    const items = this.shadowRoot.querySelectorAll(".items .item:not(:first-child)");
    const itemsData = [];

    let bError = false;
    for (let index = 0; index < items.length; index++) {
      const item = items[index];
      const selQuantity = this.shadowRoot.querySelector(`.items .item #selQty-${index}`);
      const selReason = this.shadowRoot.querySelector(`.items .item #selReason-${index}`);
      const selQtyIndex = selQuantity.selectedIndex;
      const selReaIndex = selReason.selectedIndex;

      selQuantity.classList.remove(CSS_ERROR_CLASS);
      selReason.classList.remove(CSS_ERROR_CLASS);

      if ((selQtyIndex === 0 && selReaIndex !== 0 || selQtyIndex !== 0 && selReaIndex === 0)) {
        bError = true;

        if (selQtyIndex === 0) {
          selQuantity.classList.add(CSS_ERROR_CLASS);
        }

        if (selReaIndex === 0) {
          selReason.classList.add(CSS_ERROR_CLASS);
        }
      }
      if (!bError && selQtyIndex !== 0 && selReaIndex !== 0) {
        itemsData.push({
          "lineItemId": Number(item.attributes["data-item-id"].value),
          "sku": item.attributes["data-item-sku"].value,
          "quantity": Number(selQuantity[selQuantity.selectedIndex].value),
          "reason": selReason[selReason.selectedIndex].value
        });
      }
    }

    if (!bError && itemsData.length > 0) {
      const payload = {
        "returnItems": itemsData
      };
      return payload;
    } else {
      // no items selected and no error, then mark the first line in error
      if (items.length >= 1 && !bError) {
        const item = this.shadowRoot.querySelector(".items .item:nth-child(1)");
        const selQuantity = this.shadowRoot.querySelector(`#selQty-0`);
        const selReason = this.shadowRoot.querySelector(`#selReason-0`);

        selReason.classList.add(CSS_ERROR_CLASS);
        selQuantity.classList.add(CSS_ERROR_CLASS);
        this.setError({ message: ERR_EMPTY_FIELDS, resetInvite: false }, 2);
      }
    }

    return null;
  }

  insertItemsInForm(items) {
    const { STEP2, ITEM_LB_NR, ITEM_LB_LABEL, ITEM_LB_QUANTIY, ITEM_LB_REASON } = this.settings;
    const titlesHtml = this.getItemHeaders();
    const content = this.shadowRoot.querySelector(`.step${this.step} .content`);
    const itemsHtml = items.map((item, index) => {
      //Reason select
      let reasonSelect = `<select id="selReason-${index}" onChange="(event) => this.resetSelectError(event);">`;
      reasonSelect += `<option value="---" selected></option>`;

      for (const [code, label] of Object.entries(this.reasons)) {
        reasonSelect += `<option value="${code}">${label}</option>`;
      }
      reasonSelect += '</select>';

      //Qty select
      let qtySelect = `<select id="selQty-${index}" onChange="(event) => this.resetSelectError(event);">`;
      for (let i = 0; i <= item.quantity; i++) {
        qtySelect += `<option value="${i}" ${i === 0 ? "selected" : ""}>${i}</option>`;
      }
      qtySelect += '</select>';
      const nr = `${index + 1}`.padStart(2, '0');
      const itemHtml = `<div class="item" data-item-id="${item.lineItemId}" data-item-sku="${item.sku}"><div class="nr"><span class="mobileTitles">${ITEM_LB_NR}&nbsp;</span>${nr}</div><div class="photo"></div><div class="itemLabel"><span class="mobileTitles">${ITEM_LB_LABEL}</span>${item.title || ""}<br>${item.sku || ""}<br>${item.variant.title || ""}</div><div class="itemQuantity"><span class="mobileTitles">${ITEM_LB_QUANTIY}</span>${qtySelect}</div><div class="itemReason"><span class="mobileTitles">${ITEM_LB_REASON}</span>${reasonSelect}</div></div>`;

      return itemHtml;
    });

    content.innerHTML = `<div class="orderReturn">\n<div class="items">${titlesHtml}${itemsHtml.join("\n")}</div></div>`;

    // add product image
    Promise.all(items.map(item => this.getProductImage(item.lineItemId, item.productId)));

    // add cta
    const contentCta = this.shadowRoot.querySelector('.step2 .cta .errorMessage');

    contentCta.insertAdjacentHTML('afterend', `<button id="confirmReturn" type="button" >${STEP2.BTN_CONFIRM}</button>`);

    this.shadowRoot.getElementById('confirmReturn').onclick = () => this.confirmReturn();
  }

  insertItemsNotAvailable() {
    const { STEP2 } = this.settings;
    const content = this.shadowRoot.querySelector('.step2 .invite');
    content.innerHTML = `${STEP2.NO_ITEMS_AVAILABLES}`;

    if (queryParams) {
      //add cta
      this.insertBackButton();
    }
  }

  insertListingOrderReturns(orderReturns) {
    const content = this.shadowRoot.querySelector('.step3 .content');
    const orderReturnsHtml = orderReturns.map((order) => {
      return this.getOrderData(order.reference, order);
    });

    content.innerHTML = orderReturnsHtml.join('');

    // add product image
    Promise.all(orderReturns.map(order => order.items.map(item => this.getProductImage(`${order.reference}-${item.lineItemId}`, item.productId))));

    if (queryParams) {
      // add cta
      this.insertBackButton();
    }
  }

  insertOrderReturn(order) {
    const { CNF_MESSAGE_EMAIL } = this.settings;
    const step = this.step;
    const invite = this.shadowRoot.querySelector(`.step${step} .invite`);
    const content = this.shadowRoot.querySelector(`.step${step} .content`);

    invite.innerHTML = CNF_MESSAGE_EMAIL;
    content.innerHTML = this.getOrderData(order.reference, order);

    // add product image
    Promise.all(order.items.map(item => this.getProductImage(`${order.reference}-${item.lineItemId}`, item.productId)));

    if (queryParams) {
      // add cta
      this.insertBackButton();
    }

    this.scrollTop();
  }

  getOrderData(prefix, data) {
    const { ITEM_LB_NR, ITEM_LB_LABEL, ITEM_LB_QUANTIY, ITEM_LB_REASON } = this.settings;

    const reference = data.reference;
    const items = data.items;
    const createdAt = data.createdAt;
    const titlesHtml = this.getItemHeaders();
    const itemsHtml = items.map((item, index) => {
      const nr = `${index + 1}`.padStart(2, '0');
      const itemHtml = `<div class="item" data-item-id="${prefix}-${item.lineItemId}" data-item-sku="${item.sku}"><div class="nr"><span class="mobileTitles">${ITEM_LB_NR}&nbsp;</span>${nr}</div><div class="photo"></div><div class="itemLabel"><span class="mobileTitles">${ITEM_LB_LABEL}</span>${item.title || ""}<br>${item.sku || ""}<br>${item.variant.title || ""}</div><div class="itemQuantity center"><span class="mobileTitles">${ITEM_LB_QUANTIY}</span>${item.quantity}</div><div class="itemReason center"><span class="mobileTitles">${ITEM_LB_REASON}</span>${this.reasons[item.reason]}</div></div>`;

      return itemHtml;
    });

    return `<div class="orderReturn"><h6>${this.getConfirmationMessage(reference, createdAt)}</h6>\n<div class="items">${titlesHtml}${itemsHtml.join("\n")}</div></div>`;
  }

  insertBackButton() {
    const { URL_ACCOUNT_SUFFIX, URL_USER_ACCOUNT, RETURNS_BTN_BACK } = this.settings;
    const step = this.step;
    const contentCta = this.shadowRoot.querySelector(`.step${step} .cta .errorMessage`);
    contentCta.insertAdjacentHTML('afterend', `<button id="backBtn" type="button">${RETURNS_BTN_BACK}</button>`);
    this.shadowRoot.getElementById('backBtn').onclick = () => window.location = `${URL_USER_ACCOUNT}${URL_ACCOUNT_SUFFIX}`;
  }

  getConfirmationMessage(reference, createdAt) {
    const { CNF_MESSAGE } = this.settings;

    return CNF_MESSAGE.replace('{reference}', `<strong>${reference}</strong>`).replace('{createdAt}', `<strong>${this.formatDate(createdAt)}</strong>`);
  }

  getItemHeaders() {
    const { ITEM_LB_NR, ITEM_LB_LABEL, ITEM_LB_QUANTIY, ITEM_LB_REASON } = this.settings;
    return `<div class="item head"><div class="nr">${ITEM_LB_NR}</div><div class="itemLabel">${ITEM_LB_LABEL}</div><div class="itemQuantity center">${ITEM_LB_QUANTIY}</div><div class="itemReason center">${ITEM_LB_REASON}</div></div>`;
  }

  formatDate(date) {
    if (date) {
      const locale = navigator.languages[0] || "en-US";
      const result = new Date(date);

      return result.toLocaleString(locale, { year: "numeric", month: "2-digit", day: "2-digit" });
    }
    return "";
  }

  hideStep(step) {
    this.shadowRoot.querySelector(`.order-returns .step${step}`).classList.add("hidden");
  }

  showStep() {
    const prevStep = this.step - 1;

    if (prevStep > 0) this.hideStep(prevStep);

    this.toggleLoader(false);
    this.updateStep();
  }

  toggleLoader(bStart) {
    const loader = this.shadowRoot.getElementById("loader");

    if (loader) {
      if (bStart) {
        loader.style.display = "block";
      } else {
        loader.style.display = "none";
      }
    }
  }

  resetSelectError(select) {
    select.classList.remove("hasError");
    this.resetError();
  }

  onBlurField({ originalTarget: field }) {
    this.resetError();
    if ("" + field.value.trim() !== "") {
      field.classList.remove(CSS_ERROR_CLASS);
    }
  }

  resetError() {
    for (const step of Object.values(STEPS)) {
      const errorMessage = this.shadowRoot.querySelector(`.step${step} .errorMessage`);
      errorMessage.innerHTML = "";
    }
  }

  setError(err, step) {
    const errorMessage = this.shadowRoot.querySelector(`.step${step} .errorMessage`);
    const message = err.message;

    errorMessage.innerHTML = message;

    // empty invite message, if any and if error.resetInvite
    if (typeof err.resetInvite === "undefined" || err.resetInvite && err.resetInvite !== false) {
      const invite = this.shadowRoot.querySelector(`.step${step} .invite`);

      if (invite) {
        invite.innerHTML = "";
      }
    }
  }

  checkErrors(arrFields) {
    const { ERR_EMPTY_FIELDS } = this.settings;
    let isValid = true;
    const errorMessage = this.shadowRoot.querySelector(".errorMessage");
    errorMessage.innerHTML = "";

    arrFields.forEach((item, index) => {
      const field = this.shadowRoot.querySelector(`#${item}`);
      const type = field.attributes["type"].value;
      const value = ("" + field.value).trim();

      if (type === "email" && (!emailRegex.test(value))) {
        field.classList.add(CSS_ERROR_CLASS);
        isValid = false;
      } else if (type === "text" && value === "") {
        field.classList.add(CSS_ERROR_CLASS);
        isValid = false;
      }
    });

    if (!isValid) {
      errorMessage.innerHTML = ERR_EMPTY_FIELDS;
    }
    return isValid;
  }

  scrollTop() {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  }

  async getProductImage(itemLineId, productId) {
    const { RETURNS_TOKEN } = this.settings;
    if (cacheMap.has(productId)) {
      this.insertProductImage(itemLineId, productId);
      return Promise.resolve();
    }

    const accessToken = `${RETURNS_TOKEN}`;
    const query = `query SpecificProduct($id: ID!) {
							node(id: $id) {
									id
									... on Product {
											id
											handle
											title
											images(first: 1) {
													edges {
															node {
																	transformedSrc(maxWidth: 70)
															}
													}
											}
									}
							}
					}`;
    const params = {
      query: query,
      variables: { id: btoa(`gid://shopify/Product/${productId}`) }
    };
    const optionsQuery = {
      method: "post",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "X-Shopify-Storefront-Access-Token": accessToken
      },
      body: JSON.stringify(params)
    };

    try {
      const response = await fetch(`${this.shopUrl}/api/graphql`, optionsQuery);

      if (!response.ok) {
        throw new Error("Error loading product image");
      }

      const result = await response.json();

      const { data: { node: { title, images: { edges: [{ node: { transformedSrc } }] } } } } = result;
      if (transformedSrc) {
        cacheMap.set(productId, { imageSrc: transformedSrc, title });
        this.insertProductImage(itemLineId, productId);
      }

    } catch (err) {
      console.log("Error", err);
    }
  }

  insertProductImage(itemLineId, productId) {
    const targetImage = this.shadowRoot.querySelector(`div[data-item-id="${itemLineId}"]`);
    const imgDetails = cacheMap.get(productId);

    if (targetImage && imgDetails) {
      const imgProduct = new Image();
      imgProduct.src = imgDetails.imageSrc;
      imgProduct.alt = imgDetails.title;

      targetImage.childNodes[1].appendChild(imgProduct);
    } else {
      console.log("ERROR", { itemLineId, productId })
    }
  }

  getHtml() {
    const {
      IMAGE_LOADER,
      STEP1 = {},
      STEP2 = {},
      STEP3 = {},
    } = this.settings;

    return `
      <div class="container">
        <div class="order-returns">
            <div id="loader" class="loader">
                <div class="wrapper center">
                    <img src="${IMAGE_LOADER}">
                </div>
            </div>
            <div class="main step1 hidden">
                <div class="title">${STEP1.TITLE}</div>
                <div class="row">
                    <input value="" class="" type="text" id="orderNumber" placeholder="${STEP1.ORDERNR_PLACEHOLDER}" />
                </div>
                <div class="row">
                    <input value="" type="email" id="customerEmail" placeholder="${STEP1.EMAIL_PLACEHOLDER}" />
                </div>
                <div class="cta">
                    <div class="errorMessage"></div>
                    <button id="startReturn" type="button">${STEP1.BTN_START}</button>
                </div>
            </div>
            <div class="main step2 hidden">
                <div class="title">${STEP2.TITLE}</div>
                <div class="invite subtitle">${STEP2.INVITE}</div>
                <div class="content"></div>
                <div class="cta">
                    <div class="errorMessage"></div>
                    <!- cta dynamically inserted -->
                </div>
            </div>
            <div class="main step3 hidden">
                <div class="title">${STEP3.TITLE}</div>
                <div class="invite"></div>
                <div class="content"></div>
                <div class="cta">
                  <div class="errorMessage"></div>
                    <!- cta dynamically inserted -->
                </div>
            </div>
        </div>
      </div>
    `;
  }
}

// tag to include in the template page for the OZ App Order Return (ex. <oz-app-order-return></oz-app-order-return>)
window.customElements.define('oz-app-order-return', OrderReturn);